import { Contrast } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface PartiallyDeliveredBadgeProps {
  label: string;
}

/**
 * BOXY-378 — "this order was partially delivered", shown after it moved on.
 * The list passes the short label; the order page passes the detailed one.
 */
export function PartiallyDeliveredBadge({ label }: PartiallyDeliveredBadgeProps) {
  return (
    <Badge
      variant='outline'
      className='gap-1 whitespace-nowrap border-emerald-200 bg-emerald-50 text-[11px] text-emerald-700'
    >
      <Contrast className='h-3 w-3' aria-hidden='true' />
      {label}
    </Badge>
  );
}
